// extracted by mini-css-extract-plugin
module.exports = {"grid":"ProductCardList_grid__5GFOg"};